import { qwanyxCollection } from 'qwanyx';

export async function getChildrenItems(parentId) {
    try {
        const collection = qwanyxCollection();

        // Query to match the provided parentId
        const query = { ed: parentId };

        // Fetch and project the specified fields - ADDED icon field
        const items = await collection
            .find(query, { 
                projection: { 
                    _id: 1, 
                    pa: 1, 
                    ed: 1, 
                    di: 1, 
                    title: 1, 
                    firstname: 1, 
                    name: 1, 
                    brief: 1, 
                    isFolder: 1, 
                    vi: 1,
                    icon: 1  // Add icon field for ImageIconGrid
                } 
            });

        // Return the full items instead of just the _id
        return items;
    } catch (error) {
        console.error("Error fetching items from Qwanyx:", error);
        throw error;
    }
}